export default "__VITE_ASSET__BPAXdifR__"